import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"
import { cn } from "../../../utils/cn"

/**
 * 표준 체크박스.
 *
 * 의도:
 *   - Tailwind JIT/purge 이슈와 관계없이 항상 시각적으로 보이도록 인라인 style 로 기본 스타일 강제.
 *   - className 으로 size/color override 가능 (예: `h-5 w-5 data-[state=checked]:bg-orange-500`).
 *   - Radix data-state=checked|unchecked 를 CSS selector 로 받아 배경/아이콘 전환.
 */
const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, style, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn("mh-checkbox-root", className)}
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      width: 18,
      height: 18,
      borderRadius: 4,
      borderWidth: 1.5,
      borderStyle: "solid",
      cursor: "pointer",
      transition: "background-color 0.15s ease, border-color 0.15s ease",
      boxSizing: "border-box",
      verticalAlign: "middle",
      ...style,
    }}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check style={{ width: 14, height: 14 }} strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
